import { useMutation } from "react-query";
import { postDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../helpers/errorHandler";

export type TLockUnlockUserPayload = {
  userId: string;
  reasonId: number;
  additionalInfo?: string;
};

const lockAdminUser = async (
  payload: TLockUnlockUserPayload,
): Promise<void> => {
  await postDataWithDotNet(ajaxEndpoints.LOCK_ADMIN_USER, payload);
};

export function useLockAdminUser() {
  const [mutate, result] = useMutation(
    (payload: TLockUnlockUserPayload) => lockAdminUser(payload),
    {
      onSuccess: (_data) => {
        console.log("_data: ", _data);
        message.success(`User has been locked successfully.`);
      },
      onError: (error: any) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useLockAdminUser.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
